export const routes = (prefix, pre) => [
    {
        name: `${prefix}.${pre}.cashout-report.index`,
        path: `/${prefix}/${pre}/cashout-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.cashout-report.index`,
                PageDescription: "Accounts/Finance Reports: Cashout report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.prints.cashout-report.index`,
        path: `/${prefix}/${pre}/cashout-report/print`,
        component: () => import('./prints/CashOutReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.cashout-report.index`,
                PageDescription: "Accounts/Finance Reports: Cashout report",
            },
            print: true,
        },
    },
];